import { Typography, Grid, Button, Fade } from "@material-ui/core";
import Logo from "../../img/loginLogo.png";
import { Form, Formik } from "formik";
import TextFieldwraper from "../../components/TextField";
import React from "react";

import {
  initialValue,
  validationSchema,
} from "../../validation/ForgetPasswordValidation";
import { recoverPassWord } from "../../redux/Login/LoginActions";

import Captcha from "../../components/Captcha";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Store from "../../redux/Store";
import {
  authUnauthorizedMessage,
  setCaptchaCode,
  setLoginRecoverContact,
} from "../../redux/Login/LoginActionCreators";

const ForgetPassWord = ({ authError, captchaCode }) => {
  // const [count, setCount] = React.useState(1);
  const history = useHistory();
  React.useState(() => {
    Store.dispatch(setCaptchaCode(""));
    Store.dispatch(authUnauthorizedMessage(null));
  }, []);

  return (
    <>
      <Formik
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={(values, props) => {
          recoverPassWord(values).then((res) => {
            if (!res) return;
            Store.dispatch(setLoginRecoverContact(values.username));
            // setCount(count + 1);
            // props.resetForm();
          });
        }}
        validateOnMount
      >
        {(formik) => {
          return (
            <Form>
              <Fade in={true} timeout={500}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  style={{
                    height: "100vh",
                    backgroundColor: "#F2F2F6",
                  }}
                >
                  <Grid
                    container
                    item
                    justifyContent="center"
                    spacing={4}
                    xs={10}
                    sm={6}
                    md={5}
                    lg={4}
                    xl={3}
                    style={{
                      backgroundColor: "white",
                      borderRadius: "20px",
                      boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
                      paddingTop: "51px",
                      paddingBottom: "51px",
                    }}
                  >
                    <Grid
                      item
                      md={10}
                      xs={12}
                      container
                      justifyContent="center"
                      spacing={3}
                    >
                      <Grid item xs={12} container justifyContent="center">
                        <img src={Logo} alt="logo" />
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography variant="subtitle1" color="textSecondary">
                          برای دریافت رمز جدید شماره موبایل یا ایمیل خود را وارد
                          کنید
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Typography variant="button" color="secondary">
                          {authError}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <TextFieldwraper
                          name="username"
                          label="ورود شماره موبایل / ایمیل"
                        />
                      </Grid>

                      <Grid item xs={12} container justifyContent="center">
                        <Captcha />
                      </Grid>

                      <Grid item xs={12} container justifyContent="center">
                        <Typography
                          variant="button"
                          color="primary"
                          style={{ cursor: "pointer", fontWeight: "bold" }}
                          onClick={() => history.push("/")}
                        >
                          ورود با حساب کاربری
                        </Typography>
                      </Grid>
                      <Grid item xs={12} container justifyContent="center">
                        <Button
                          fullWidth
                          variant="contained"
                          color="primary"
                          disabled={!formik.isValid || captchaCode === ""}
                          type="submit"
                        >
                          تایید
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Fade>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { recoverCode, captchaCode, showCaptcha, authError } = loginReducer;

  return {
    recoverCode,
    captchaCode,
    showCaptcha,
    authError,
  };
};
export default connect(mapStateToProps)(ForgetPassWord);
